import React from 'react'
import RiskHorizontalDisplay from './RiskHorizontalDisplay'

const ExportPdfV2 = ({
  feedbackDetailData,
  selectedOption,
  comment,
  selectedIndex,
}) => {
  const { feedbackComments } = feedbackDetailData

  const contentData = feedbackComments?.find(
    item => item.id === Number(selectedIndex)
  )

  return (
    <div
      id="divToPrintPart2"
      style={{ margin: '20mm', pageBreakInside: 'avoid' }}>
      <RiskHorizontalDisplay
        labels={[
          {
            value: (
              <div style={{ textAlign: 'center' }}>
                <div>Ý KIẾN CỦA THÀNH VIÊN HỘI ĐỒNG QUẢN TRỊ (01 đề xuất)</div>
              </div>
            ),
            style: { margin: '10px 0', border: '1px solid white' },
          },
        ]}
        tableStyle={{ margin: '0 0 0 140px', width: '100%' }}
      />

      <RiskHorizontalDisplay
        results={[
          {
            value: (
              <div
                style={{
                  margin: '0 0 8px 0',
                  textAlign: 'justify',
                  lineHeight: '1.2',
                }}
                dangerouslySetInnerHTML={{
                  __html: contentData && contentData?.content,
                }}></div>
            ),
            style: {
              textAlign: 'flex',
              border: '1px solid white',
              margin: '0 10px',
            },
          },
        ]}
        tableStyle={{ margin: '0 0 0 40px', width: '90%' }}
      />

      <RiskHorizontalDisplay
        labels={[
          {
            image: (
              <table
                style={{
                  border: '1px solid white',
                  width: '100%',
                  borderCollapse: 'collapse',
                }}>
                <tbody>
                  <tr>
                    <td
                      style={{
                        border: '1px solid #d9d9d9',
                        padding: '8px 12px',
                        backgroundColor: '#fafafa',
                        fontSize: '12pt',
                        textAlign: 'left',
                      }}>
                      Đồng ý:
                    </td>
                    <td
                      style={{
                        border: '1px solid #d9d9d9',
                        padding: '8px 12px',
                        backgroundColor: '#fafafa',
                        textAlign: 'center',
                        width: '40px',
                      }}>
                      <img
                        id="logo"
                        style={{ width: '20px', height: '16px' }}
                        src={
                          selectedOption && selectedOption === 'AGREE'
                            ? `${window.location.protocol}//${window.location.host}/assets/icons/checkedbox.PNG`
                            : `${window.location.protocol}//${window.location.host}/assets/icons/uncheckedbox.PNG`
                        }
                        alt="checkbox"
                      />
                    </td>
                  </tr>

                  <tr>
                    <td
                      style={{ height: '6px', border: 'none' }}
                      colSpan={2}></td>
                  </tr>

                  <tr>
                    <td
                      style={{
                        border: '1px solid #d9d9d9',
                        padding: '8px 12px',
                        backgroundColor: '#fafafa',
                        fontSize: '12pt',
                        textAlign: 'left',
                      }}>
                      Không đồng ý:
                    </td>
                    <td
                      style={{
                        border: '1px solid #d9d9d9',
                        padding: '8px 12px',
                        backgroundColor: '#fafafa',
                        textAlign: 'center',
                        width: '40px',
                      }}>
                      <img
                        id="logo"
                        style={{ width: '20px', height: '16px' }}
                        src={
                          selectedOption && selectedOption === 'DISAGREE'
                            ? `${window.location.protocol}//${window.location.host}/assets/icons/checkedbox.PNG`
                            : `${window.location.protocol}//${window.location.host}/assets/icons/uncheckedbox.PNG`
                        }
                        alt="checkbox"
                      />
                    </td>
                  </tr>

                  <tr>
                    <td
                      style={{ height: '6px', border: 'none' }}
                      colSpan={2}></td>
                  </tr>

                  <tr>
                    <td
                      style={{
                        border: '1px solid #d9d9d9',
                        padding: '8px 12px',
                        backgroundColor: '#fafafa',
                        fontSize: '12pt',
                        textAlign: 'left',
                      }}>
                      Không có ý kiến/ Ý kiến khác:
                    </td>
                    <td
                      style={{
                        border: '1px solid #d9d9d9',
                        padding: '8px 12px',
                        backgroundColor: '#fafafa',
                        textAlign: 'center',
                        width: '40px',
                      }}>
                      <img
                        id="logo"
                        style={{ width: '20px', height: '16px' }}
                        src={
                          selectedOption && selectedOption === 'OTHER'
                            ? `${window.location.protocol}//${window.location.host}/assets/icons/checkedbox.PNG`
                            : `${window.location.protocol}//${window.location.host}/assets/icons/uncheckedbox.PNG`
                        }
                        alt="checkbox"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            ),
            style: { margin: '10px 0', border: '1px solid white' },
          },
        ]}
        tableStyle={{ margin: '0 0 0 40px', width: '60%' }}
      />

      <RiskHorizontalDisplay
        labels={[
          {
            image: (
              <div
                dangerouslySetInnerHTML={{
                  __html: comment && comment,
                }}
                style={{
                  margin: '0 0 8px 0',
                  textAlign: 'justify',
                  lineHeight: '1.2',
                }}></div>
            ),
            style: {
              textAlign: 'flex',
              border: '1px solid white',
              margin: '0 10px',
            },
          },
        ]}
        tableStyle={{ margin: '0 0 0 40px', width: '90%' }}
      />

      <RiskHorizontalDisplay
        labels={[
          {
            image: (
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontStyle: 'italic' }}>
                  ..........................., ngày {'    '} tháng {'    '} năm{' '}
                  {'     '}
                </div>
                <div style={{ margin: '10px 0' }}>
                  THÀNH VIÊN HỘI ĐỒNG QUẢN TRỊ
                </div>
                <div style={{ fontStyle: 'italic' }}>(ký tên)</div>
              </div>
            ),
            style: { margin: '0', border: '1px solid white' },
          },
        ]}
        tableStyle={{ margin: '0 0 0 350px' }}
      />
    </div>
  )
}

export default ExportPdfV2
